import ItemNoticia from './ItemNoticia';
import ItemNoticiaAmp from './ItemNoticiaAmp';
import { useAmp } from 'next/amp';

export default function Component(props) {
    const isAmp = useAmp();
    return isAmp ? <ItemNoticiaAmp {...props} /> : <ItemNoticia {...props} />;
}
